import { Component } from '@angular/core';
import { NavController,NavParams } from 'ionic-angular';

import { WebService } from '../../../providers/service/webservice';
import { QUERYCALENDAR } from '../../../providers/config/serviceurl';
import { Utils } from '../../../providers/service/utils';
import { StorageService } from '../../../providers/service/storageservice';
import { AppState } from '../../../app/app.global';

@Component({
  selector: 'page-selCalendar',
  templateUrl: 'selcalendar.html'
})
export class SelCalendarPage {

	trip:any;
	currentUser:any;
	privateCalendars :any[];
	publicCalendars :any[];
	calendars = [
		{id:1,name:'测试日历'},
		{id:2,name:'个人日历'},
		{id:3,name:'学习日历'}
	];


  constructor(public navCtrl: NavController,public params: NavParams,private webService:WebService,public global: AppState) {
			this.trip =  params.data.trip;
			this.currentUser = StorageService.getObj("currentUser");
			this.queryList();
  }

  setCalendar(item:any){
	  	if(item){
		  	this.trip.calendarId = item.id;
		  	this.trip.calendar = item.name;
		  	this.trip.type = item.type;
		  	this.trip.color = item.color;
	  	}
      this.navCtrl.pop();
	  	//this.navCtrl.push(TripAddPage, { trip: this.trip });
  }
  //查询数据
  queryList(){
  		var params = {'userId':this.currentUser.userId};
			this.webService.post(QUERYCALENDAR,params,"查询日历").then(anyObj =>this.handleThings(anyObj));
  }
  //处理数据
  handleThings(obj :any){
		if(obj){
			this.privateCalendars = obj.privateCalendars;
			if(this.privateCalendars){
				for(var i=0;i<this.privateCalendars.length;i++){
					this.privateCalendars[i].isShow = Utils.formatTrueOrFalse(this.privateCalendars[i].isShow);
					this.privateCalendars[i].isRemind = Utils.formatTrueOrFalse(this.privateCalendars[i].isRemind);
				}
			}

			this.publicCalendars = obj.publicCalendars;
			if(this.publicCalendars){
				for( i=0;i<this.publicCalendars.length;i++){
					this.publicCalendars[i].isShow = Utils.formatTrueOrFalse(this.publicCalendars[i].isShow);
					this.publicCalendars[i].isRemind = Utils.formatTrueOrFalse(this.publicCalendars[i].isRemind);
				}
			}

		}
	}

}



// WEBPACK FOOTER //
// ./src/pages/trip/calendar/selcalendar.ts